var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseProfileMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9285 10.9304C11.2409 10.618 11.7474 10.618 12.0598 10.9304L25.0706 23.9412C25.383 24.2536 25.383 24.7601 25.0706 25.0726C24.7582 25.385 24.2516 25.385 23.9392 25.0726L10.9285 12.0618C10.616 11.7494 10.616 11.2429 10.9285 10.9304Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.929 25.0725C10.6165 24.7601 10.6165 24.2536 10.929 23.9412L23.9397 10.9304C24.2522 10.618 24.7587 10.618 25.0711 10.9304C25.3835 11.2428 25.3835 11.7493 25.0711 12.0618L12.0603 25.0725C11.7479 25.3849 11.2414 25.3849 10.929 25.0725Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseProfileMenu);
export default __webpack_public_path__ + "static/media/closeProfileMenu.e92e21e0b9f47f9719120e9f7ed9a23f.svg";
export { ForwardRef as ReactComponent };